// extracted by mini-css-extract-plugin
export var container = "_h6-1";
export var cornerButtonContainer = "_h6-6";
export var disabled = "_h6-2";
export var dragActive = "_h6-3";
export var fileContainer = "_h6-5";
export var hiddenInput = "_h6-4";
export var widthContainer = "_h6-0";